import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SES, AWSError } from 'aws-sdk';
import { SendEmailRequest, SendEmailResponse } from 'aws-sdk/clients/ses'
import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private http: HttpClient) {
   
   }

    async send(to:any, subjetc:any, template:any) {
      
      const uri = 'https://backend-xtensa-core.app.inpronet.es/email';
      await axios.post(uri, {
        "to": to,
        "subject": subjetc,
        "html": template,
      })
      .then(response => {
        console.log("Mail send!");
      })
      .catch(error => {
        console.log('An error occurred:', error.response);
      });

}


/* async forgotPassword() {
  const uri = 'https://xtensa-backup.app.inpronet.es/email';
  await axios.post(uri,
    {
      "to" : "elplanbee@gmail.com",
      "subject" : "Correo enviado desde Xtensa",
      "html" : `<h1>Welcome on mywebsite.fr!</h1>
      <p>Your account is now linked with: <%= user.email %>.<p>`,
   },
   )
  .then(response => {
    console.log("Your user's password has been reset.");
  })
  .catch(error => {
    console.log('An error occurred:', error.response);
  }); 
  
    


}*/



}
